<template>
  <v-container>
    <v-card elevation="4" class="mt-6">
      <v-card-title class="font-weight-bold d-flex align-center">
        <v-icon color="green" class="mr-2">mdi-shield-check</v-icon>
        Status de Validação do Questionário
        <v-spacer></v-spacer>
        <!-- Botão de novo status ocultado -->
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col v-for="status in statusList" :key="status.id" cols="12" md="6" lg="4">
            <v-card outlined class="mb-4">
              <v-card-title class="d-flex align-center justify-space-between">
                <div>
                  <v-icon color="green" left>mdi-server</v-icon>
                  <strong>{{ status.descricao }}</strong>
                  <span class="ml-2 grey--text">(ID: {{ status.id }})</span>
                </div>
                <div>
                  <v-btn icon color="primary" @click="abrirModal(status)"><v-icon>mdi-pencil</v-icon></v-btn>
                  <!-- Botão de excluir ocultado -->
                </div>
              </v-card-title>
              <v-card-text>
                <div><strong>Validação:</strong> {{ getValidacaoDescricao(status.validacao) }}</div>
                <div><strong>Cargo:</strong> {{ getCargoDescricao(status.cargo) }}</div>
                <div><strong>Grupo:</strong> {{ getGrupoDescricao(status.grupo) }}</div>
                <div><strong>Bloq Cargo:</strong> {{ getCargoDescricao(status.bloq_cargo) }}</div>
                <div><strong>Bloq Grupo:</strong> {{ getGrupoDescricao(status.bloq_grupo) }}</div>
                <div><strong>Gestor:</strong> {{ status.gestor }}</div>
                <div><strong>Alunos:</strong> {{ status.alunos }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-title class="headline">{{ statusEditando.id ? "Editar Status" : "Novo Status" }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="statusEditando.descricao" label="Descrição" outlined class="mb-2" />
          <v-select
            v-model.number="statusEditando.validacao"
            :items="[1, 2, 3, 4, 5]"
            label="Validação (obrigatório)"
            outlined
            class="mb-2"
            :rules="[(v) => !!v || 'Selecione a validação']"
            required
          />
          <v-select
            v-model="statusEditando.cargoArr"
            :items="listaCargos"
            item-text="descricao"
            :item-value="(item) => String(item.pkcargo)"
            label="Cargo"
            multiple
            outlined
            class="mb-2"
            chips
          />
          <v-select
            v-model="statusEditando.bloqCargoArr"
            :items="listaCargos"
            item-text="descricao"
            :item-value="(item) => String(item.pkcargo)"
            label="Bloq Cargo"
            multiple
            outlined
            class="mb-2"
            chips
          />
          <v-select
            v-model="statusEditando.grupoArr"
            :items="listaGrupos"
            item-text="descricao"
            :item-value="(item) => String(item.pkgrupo)"
            label="Grupo"
            multiple
            outlined
            class="mb-2"
            chips
          />
          <v-select
            v-model="statusEditando.bloqGrupoArr"
            :items="listaGrupos"
            item-text="descricao"
            :item-value="(item) => String(item.pkgrupo)"
            label="Bloq Grupo"
            multiple
            outlined
            class="mb-2"
            chips
          />
          <v-switch v-model="statusEditando.gestor" label="Gestor" :true-value="1" :false-value="0" class="mb-2" />
          <v-switch v-model="statusEditando.alunos" label="Alunos" :true-value="1" :false-value="0" class="mb-2" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="salvarStatus">Salvar</v-btn>
          <v-btn text @click="fecharModal">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3500" top>
      {{ snackbarText }}
    </v-snackbar>
    <div>
      <v-dialog v-model="showAguardar" max-width="500px">
        <v-card class="pa-5" color="teal" dark> aguarde.... </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "StatusValidacao",
  data() {
    return {
      statusList: [],
      showAguardar: false,
      modal: false,
      statusEditando: {
        id: null,
        descricao: "",
        validacao: 1,
        cargo: "",
        grupo: "",
        bloq_cargo: "",
        bloq_grupo: "",
        gestor: 0,
        alunos: 1,
      },
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  computed: {
    ...mapGetters({
      listaCargos: "avaliacao/listaCargos",
      listaGrupos: "avaliacao/listaGrupos",
      validacoes: "avaliacao/validacoes",
    }),
  },
  methods: {
    prepararStatusEditandoParaSalvar() {
      // Remove duplicados antes de salvar
      const uniq = (arr) => Array.from(new Set(Array.isArray(arr) ? arr.map(String) : []));
      this.statusEditando.cargo = uniq(this.statusEditando.cargoArr).join(",");
      this.statusEditando.bloq_cargo = uniq(this.statusEditando.bloqCargoArr).join(",");
      this.statusEditando.grupo = uniq(this.statusEditando.grupoArr).join(",");
      this.statusEditando.bloq_grupo = uniq(this.statusEditando.bloqGrupoArr).join(",");
    },
    getValidacaoDescricao(validacao) {
      return this.validacoes[validacao] || `[Código não encontrado: ${validacao}]`;
    },
    getGrupoDescricao(gruposStr) {
      if (!gruposStr) return "";
      if (!this.listaGrupos || this.listaGrupos.length === 0) {
        return "[Lista de grupos não carregada] (" + gruposStr + ")";
      }
      const codigos = String(gruposStr)
        .split(",")
        .map((c) => (c !== null && c !== undefined ? String(c).trim() : ""))
        .filter(Boolean);
      const descricoes = codigos.map((cod) => {
        const grupo = this.listaGrupos.find((g) => String(g.pkgrupo).trim() === cod);
        if (!grupo) {
          return "[Código não encontrado: " + cod + "]";
        }
        return grupo.descricao;
      });
      return descricoes.join(", ");
    },
    ...mapActions({
      bootstrapListas: "avaliacao/bootstrapListas",
      requestPublicoQuestionarioAll: "avaliacao/requestPublicoQuestionarioAll",
      editarPublicoQuestionario: "avaliacao/editarPublicoQuestionario",
      inserirPublicoQuestionario: "avaliacao/inserirPublicoQuestionario",
      excluirPublicoQuestionario: "avaliacao/excluirPublicoQuestionario",
    }),
    ...mapMutations({
      setStatusEditando: "avaliacao/setStatusEditando",
    }),
    async carregarStatus() {
      const resp = await this.requestPublicoQuestionarioAll();
      this.statusList = Array.isArray(resp?.data) ? resp.data : [];
    },
    getCargoDescricao(cargosStr) {
      if (!cargosStr) return "";
      if (!this.listaCargos || this.listaCargos.length === 0) {
        return "[Lista de cargos não carregada] (" + cargosStr + ")";
      }
      const codigos = String(cargosStr)
        .split(",")
        .map((c) => (c !== null && c !== undefined ? String(c).trim() : ""))
        .filter(Boolean);
      const descricoes = codigos.map((cod) => {
        const cargo = this.listaCargos.find((c) => String(c.pkcargo).trim() === cod);
        if (!cargo) {
          return "[Código não encontrado: " + cod + "]";
        }
        return cargo.descricao;
      });
      return descricoes.join(", ");
    },
    abrirModal(status = null) {
      const toArr = (str) =>
        str
          ? String(str)
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
              .map(String)
          : [];
      if (status) {
        this.statusEditando = {
          id: status.id,
          descricao: status.descricao || "",
          validacao: status.validacao != null ? Number(status.validacao) : 1,
          cargo: status.cargo || "",
          cargoArr: toArr(status.cargo),
          grupo: status.grupo || "",
          grupoArr: toArr(status.grupo),
          bloq_cargo: status.bloq_cargo || "",
          bloqCargoArr: toArr(status.bloq_cargo),
          bloq_grupo: status.bloq_grupo || "",
          bloqGrupoArr: toArr(status.bloq_grupo),
          gestor: status.gestor == 1 ? 1 : 0,
          alunos: status.alunos == 1 ? 1 : 0,
        };
        this.setStatusEditando(this.statusEditando);
      } else {
        this.statusEditando = {
          id: null,
          descricao: "",
          validacao: 1,
          cargo: "",
          cargoArr: [],
          grupo: "",
          grupoArr: [],
          bloq_cargo: "",
          bloqCargoArr: [],
          bloq_grupo: "",
          bloqGrupoArr: [],
          gestor: 0,
          alunos: 1,
        };
        this.setStatusEditando(this.statusEditando);
      }
      this.modal = true;
    },
    fecharModal() {
      this.modal = false;
    },
    async salvarStatus() {
      try {
        this.prepararStatusEditandoParaSalvar();
        if (this.statusEditando.id) {
          this.showAguardar = true;
          await this.editarPublicoQuestionario({
            id: this.statusEditando.id,
            data: { ...this.statusEditando },
          });

          this.snackbarText = "Status atualizado com sucesso!";
          this.snackbarColor = "success";
          this.showAguardar = false;
        } else {
          await this.inserirPublicoQuestionario({ ...this.statusEditando });
          this.snackbarText = "Status criado com sucesso!";
          this.snackbarColor = "success";
        }
        this.carregarStatus();
      } catch (e) {
        this.snackbarText = "Erro ao salvar status.";
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.fecharModal();
    },
    async excluirStatus(status) {
      if (!status || !status.id) return;
      try {
        await this.excluirPublicoQuestionario(status.id);
        this.snackbarText = "Status excluído com sucesso!";
        this.snackbarColor = "success";
        this.carregarStatus();
      } catch (e) {
        this.snackbarText = "Erro ao excluir status.";
        this.snackbarColor = "error";
      }
      this.snackbar = true;
    },
  },
  async mounted() {
    await this.carregarStatus();
    await this.bootstrapListas();
  },
};
</script>

<style scoped></style>
